// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1JssN","notes":"Notes_notes__2V4PL","note":"Notes_note__23X3y","markdown":"Notes_markdown__2A-ow"};